import React from 'react'
import PropTypes from 'prop-types'

import Modal from '../Modal/Modal'

import Button from '../Button/Button'
import ButtonSpacer from '../ButtonSpacer/ButtonSpacer'

import './ConfirmModal.css'

export const ConfirmModal = ({
  header,
  confirmText = 'Confirm',
  onConfirm,
  closeText = 'Cancel',
  onClose,
  hideCancel = false,
  isLoading,
  children,
  responsive = true
}) => {
  const footerButtons = (
    <div styleName='buttons'>
      <React.Fragment>
        <Button
          data-testid='confirm-modal-confirm-button'
          id='confirm-button'
          type='submit'
          style='primaryWide'
          onClick={onConfirm}
          loading={isLoading}>
          {confirmText}
        </Button>
        <ButtonSpacer vertical />
      </React.Fragment>
      {!hideCancel && (
        <Button
          data-testid='confirm-modal-cancel-button'
          id='cancel-button'
          type='submit'
          style='linkWide'
          onClick={onClose}>
          {closeText}
        </Button>
      )}
    </div>
  )

  return (
    <Modal header={header} onClose={onClose} footer={footerButtons} responsive={responsive}>
      <div data-testid='confirm-modal-body' styleName='modal'>
        { children }
      </div>
    </Modal>
  )
}

ConfirmModal.propTypes = {
  header: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  confirmText: PropTypes.string,
  children: PropTypes.node,
  closeText: PropTypes.string,
  hideCancel: PropTypes.bool,
  responsive: PropTypes.bool
}
